module.exports = __webpack_public_path__ + "img/logo-delete-type.6201dca8.svg";